const styles = `:host {
  display: flex;
  margin: 0.25rem 1rem;
}`; export default styles;